import {
  SpacingModule,
  FlexboxModule,
  GridModule,
  ImageModule,
  PanelModule,
  TitleModule,
  BreadcrumbsModule,
  SectionHeaderModule,
  PaddingModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { ProfileListComponent } from './profile-list/profile-list.component';
import { ProfileTileComponent } from './profile-tile/profile-tile.component';
import { ProfileComponent } from './profile/profile.component';

@NgModule({
  declarations: [ProfileComponent, ProfileListComponent, ProfileTileComponent],
  imports: [
    BreadcrumbsModule,
    BrSdkModule,
    CommonModule,
    FlexboxModule,
    ImageModule,
    PaddingModule,
    PanelModule,
    SectionHeaderModule,
    SpacingModule,
    TitleModule,
    GridModule,
    ImageModule,
  ],
  exports: [ProfileComponent, ProfileListComponent, ProfileTileComponent],
  entryComponents: [
    ProfileComponent,
    ProfileListComponent,
    ProfileTileComponent,
  ],
})

/**
 * Profile Module
 */
export class ProfileModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Profile List': ProfileListComponent,
      Profile: ProfileComponent,
    };
  }
}
